import { Link } from "@remix-run/react"

export interface UtilityNavLinkProps {
  label: string
  href: string
}

const UtilityNavLink = ({ label, href }: UtilityNavLinkProps) => {
  const isExternalHref = /^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(href)

  return isExternalHref ? (
    <a
      href={href}
      className="text-[12px] md:text-[13px] text-white font-light transition-colors"
    >
      {label}
    </a>
  ) : (
    <Link
      to={href}
      className="text-[12px] md:text-[13px] text-white font-light transition-colors"
    >
      {label}
    </Link>
  )
}

UtilityNavLink.displayName = "UtilityNavLink"

export { UtilityNavLink }
export default UtilityNavLink
